//
//
//
//
//
//

import { getRandomArbitrary } from "../../../src/utils/functions"

export default {
  name: "VocWaves",
  // ref: https://github.com/kopiro/siriwave#constructor-options
  props: {
    id: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      waveInstance: null,
      intervalInstance: null,
      // 默认的配置
      defaultOptions: {
        // 容器大小
        width: 300,
        height: 63,
        speed: 0.15,
        amplitude: 0.65,
        color: "#ffffff",
        cover: true,
        frequency: 2,
        curveDefinition: [
          {
            attenuation: -2,
            lineWidth: 1 * window.devicePixelRatio,
            opacity: 0.2
          },
          {
            attenuation: -0.5,
            lineWidth: 1 * window.devicePixelRatio,
            opacity: 0.6
          },
          {
            attenuation: 0.5,
            lineWidth: 2 * window.devicePixelRatio,
            opacity: 1
          }
        ]
      }
    }
  },
  computed: {
    // 合并的配置
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.options
      }
    }
  },
  mounted() {
    if (window.SiriWave) {
      const SiriWave = window.SiriWave
      this.waveInstance = new SiriWave({
        container: document.getElementById(this.id),
        ...this.mergedOptions
      })

      // this.intervalInstance = setInterval(() => {
      //   this.setSpeed()
      //   this.setAmplitude()
      // }, 500)
    }
  },
  methods: {
    startWave() {
      this.waveInstance.start()
    },
    stopWave() {
      this.waveInstance.stop()
      // 清除定时器
      if (this.intervalInstance) {
        clearInterval(this.intervalInstance)
      }
    },
    setSpeed(v = undefined) {
      const p = v || getRandomArbitrary(0.1, 0.4)
      this.waveInstance.setSpeed(p)
      //   this.$forceUpdate()
    },
    setAmplitude(v = undefined) {
      const p = v || getRandomArbitrary(0.7, 1)
      this.waveInstance.setAmplitude(p)
      //   this.$forceUpdate()
    }
  }
}
